import React, { useEffect, useState } from "react";
import FilterSelect from "component/common/FilterSelect";
import Search from "component/common/TableFilter/Search";
import queryString from "query-string";
import { useHistory, useLocation } from "react-router";
import { debounce } from "debounce";

import styles from "./DisputedFilter.module.scss";

const DisputedFilter = () => {
  const location = useLocation();

  const history = useHistory();
  const [paymentStatus, setPaymentStatus] = useState("Status");

  let [filter, setFilter] = useState({
    status: undefined,
    sort: undefined,
    buyer: undefined,
    sellerId: undefined,
    discount: undefined,
    paymentStatus: undefined,
  });

  const sortOptions = ["Sort By", "Low to High", "High to Low"];

  const statusOptions = [
    "Processing",
    "Processed",
    "Scheduled",
    "Queued",
    "Cancelled",
    "Reversed",
    "Pending",
  ];

  useEffect(() => {
    let query = queryString.parse(location.search);
    let data = {
      ...filter,
      status: query.status,
      sort:
        query.sort != undefined
          ? query.sort == "1"
            ? "Low to High"
            : "High to Low"
          : undefined,
      buyer: query.buyer === "" ? undefined : query.buyer,
      sellerId: query.sellerId === "" ? undefined : query.sellerId,
      paymentStatus: query.paymentStatus?.toLowerCase(),
    };
    setFilter(data);
    setPaymentStatus(query.paymentStatus);
  }, [location.search]);

  const handleChange = (event) => {
    let data = { ...filter, [event.name]: event.value };
    let params = {
      sellerId: data.sellerId === "" ? undefined : data.sellerId,
      sort:
        data.sort === "Low to High"
          ? "1"
          : data.sort === "High to Low"
          ? "2"
          : undefined,
      buyer: data.buyer === "" ? undefined : data.buyer,
      status: data.status === "All" ? undefined : data.status,
      paymentStatus: data.paymentStatus?.toLowerCase(),
    };
    setFilter(data);
    setPaymentStatus(data.paymentStatus);
    if (queryString.stringify(params).length === 0) {
      history.push(`/admin/dispute/list`);
    } else {
      history.push(`/admin/dispute/list?${queryString.stringify(params)}`);
    }
  };

  return (
    <tr className={styles.disputed_filter}>
      <td>
        <Search
          name="sellerId"
          onChange={debounce(handleChange, 500)}
          value={filter.sellerId ? filter.sellerId : ""}
          searchPlaceholder="Search Seller Id"
        />
      </td>
      <td />
      <td>
        <Search
          name="buyer"
          onChange={debounce(handleChange, 500)}
          value={filter.buyer ? filter.buyer : ""}
          searchPlaceholder="Search Name"
        />
      </td>
      <td />
      <td>
        <FilterSelect
          options={sortOptions}
          placeholder="Sort By"
          isSort={true}
          name="sort"
          value={filter.sort ? filter.sort : "Sort By"}
          onChange={handleChange}
        />
      </td>
      <td />
      <td>
        <FilterSelect
          options={statusOptions}
          placeholder="Status"
          name="paymentStatus"
          value={
            paymentStatus
              ? paymentStatus?.charAt(0)?.toUpperCase() +
                paymentStatus?.substring(1, paymentStatus?.length)
              : ""
          }
          onChange={handleChange}
          className="payment-filter"
        />
      </td>
      <td></td>
    </tr>
  );
};

export default DisputedFilter;
